var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "btn btn-primary ml-md-2 add-button ml-4",
      on: { click: _vm.onClickHandler }
    },
    [
      _c("span", {
        staticClass: "png-icon png-icon-icons-glyph--ko-plus mr-2"
      }),
      _vm._v("\n    " + _vm._s(_vm.buttonText) + "\n  ")
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }